export default __webpack_public_path__ + "static/media/GiftBox.c8a2aea2.png";